import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import {
    BOARD_SIZE,
    PieceVisual,
    pieceVisualRenderSizePx,
} from "../../../pages/puzzles/jigsaw/PieceVisual";

const TRAY_PIECE_SCALE = 0.45;

/**
 * Admin preview: one tray per color basket, with that basket's pieces.
 */
export default function AdminColorBasketTrays({ baskets, grid, imageUrl, paths }) {
    if (!Array.isArray(baskets) || baskets.length === 0 || !grid || !imageUrl || !paths) {
        return null;
    }

    const cellPx = BOARD_SIZE / grid;
    const renderSize = pieceVisualRenderSizePx(cellPx);
    const trayTile = renderSize * TRAY_PIECE_SCALE;

    return (
        <Stack spacing={2}>
            <Typography variant="h6">Color basket trays</Typography>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: {
                        xs: "1fr",
                        sm: "repeat(2, minmax(0, 1fr))",
                        md: "repeat(3, minmax(0, 1fr))",
                    },
                    gap: 2,
                }}
            >
                {baskets.map((basket) => {
                    const hex = basket?.dominantColorHex || "#999999";
                    const pieceIds = Array.isArray(basket?.pieceIds) ? basket.pieceIds : [];
                    return (
                        <Paper
                            key={basket?.index ?? hex}
                            variant="outlined"
                            sx={{
                                p: 1.5,
                                borderColor: hex,
                                borderWidth: 2,
                                bgcolor: "grey.900",
                                overflow: "hidden",
                            }}
                        >
                            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                <Box
                                    sx={{
                                        width: 18,
                                        height: 18,
                                        borderRadius: 0.5,
                                        bgcolor: hex,
                                        border: "1px solid",
                                        borderColor: "divider",
                                        flexShrink: 0,
                                    }}
                                />
                                <Typography variant="subtitle2" sx={{ color: "#fff", flex: 1 }}>
                                    Basket {basket?.index}
                                </Typography>
                                <Typography variant="caption" sx={{ color: "grey.400" }}>
                                    {pieceIds.length} pieces
                                </Typography>
                            </Stack>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 1.5,
                                    maxHeight: 280,
                                    overflow: "auto",
                                    p: 0.5,
                                    borderRadius: 1,
                                    bgcolor: "rgba(0,0,0,0.25)",
                                }}
                            >
                                {pieceIds.map((pieceIndex) => (
                                    <Box
                                        key={pieceIndex}
                                        sx={{
                                            transform: `scale(${TRAY_PIECE_SCALE})`,
                                            transformOrigin: "top left",
                                            width: trayTile,
                                            height: trayTile,
                                            pointerEvents: "none",
                                        }}
                                    >
                                        <PieceVisual
                                            pieceIndex={pieceIndex}
                                            imageUrl={imageUrl}
                                            grid={grid}
                                            paths={paths}
                                            bevel3d={false}
                                            showGridCoords={false}
                                            anchorToCell={false}
                                        />
                                    </Box>
                                ))}
                                {pieceIds.length === 0 && (
                                    <Typography variant="caption" color="text.secondary">
                                        No pieces
                                    </Typography>
                                )}
                            </Box>
                        </Paper>
                    );
                })}
            </Box>
        </Stack>
    );
}
